import type { RouteLocationRaw } from '#vue-router'

/**
 * State shared between the app shell (header + sidebar) and the page it wraps.
 *
 * The header lives in the layout, so pages can no longer pass their own title
 * to it. They call `usePageChrome()` instead, which writes into these refs.
 */
const pageTitle = ref('')
const previousRoute = ref<RouteLocationRaw | undefined>()

// Off-canvas sidebar on narrow screens; ignored from the mobile breakpoint up.
const sidebarOpen = ref(false)

export function useAppShell() {
  return { pageTitle, previousRoute, sidebarOpen }
}

/**
 * Sets the title the shell header shows for the current page, and the route its
 * back button returns to. `title` is a getter so the header follows a language
 * switch. Pages do not need to clean up — the next page overwrites both.
 */
export function usePageChrome(title: () => string, previous?: RouteLocationRaw) {
  watchEffect(() => {
    pageTitle.value = title()
  })
  previousRoute.value = previous
}
